// Chart colours for the light and dark themes. Charts read palette() each time they draw and are
// redrawn when the theme changes (useResolvedTheme), so SVG fills follow the theme.
const LIGHT = {
  g: '#00b386', gd: '#00916c', gl: '#ccf2e6', gs: '#7ae0c3',
  r: '#f23645', rd: '#cc2b39', rl: '#fde1e3', rs: '#f9a3aa',
  blue: '#0496ff', blueSoft: '#c2e0ff', blueMid: '#82c3ff', navy: '#0c4a6e',
  ink: '#0b1722', mute: '#71717a', mute2: '#a1a1aa', grid: '#e4e4e7', gridSoft: '#eef2f6', line: '#d4d4d8',
  panel: '#ffffff', untraded: '#f7fafe', amber: '#d97706', amberSoft: '#fef3c7',
  tagBg: '#0b1722', tagFg: '#ffffff', zero: '#e4e4e7',
};
type Palette = typeof LIGHT;
const DARK: Palette = {
  g: '#1fc99a', gd: '#34d3a6', gl: '#123f35', gs: '#2f8f74',
  r: '#ff5263', rd: '#ff7381', rl: '#47181f', rs: '#a3404b',
  blue: '#3aa9ff', blueSoft: '#1d3a5c', blueMid: '#3d79b3', navy: '#7cc4ff',
  ink: '#e8eef6', mute: '#8b9bb0', mute2: '#5f6f86', grid: '#24324a', gridSoft: '#1b2638', line: '#33435e',
  panel: '#111b2c', untraded: '#0e1727', amber: '#f5a524', amberSoft: '#3b2a0b',
  tagBg: '#e8eef6', tagFg: '#0b1722', zero: '#33435e',
};

export function palette(): Palette {
  return typeof document !== 'undefined' && document.documentElement.classList.contains('dark') ? DARK : LIGHT;
}
